// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---------- General ---------- */
body {
  font-family: BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  background-color: var(--background_color_mob);
}
@media (min-width: 768px) {
  body {
    background-color: var(--background_color);
  }
}
.main-row {
  background-color: var(--background_color);
}
/* ---------- Navbar ---------- */
.navbar {
  background-color: var(--title_red);
}
.nav-link {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.page-title {
  color: #fff;
  font-size: 1.6rem;
  font-family: 'Lucida Grande', helvetica, arial, verdana, sans-serif;
  font-weight: bold;
  text-decoration: none;
  vertical-align: middle;
}
.page-title a {
  color: #fff;
}
.page-title:hover {
  color: #fff;
}
.login-block {
  position: absolute;
  right: 50px;
  top: 10px;
  z-index: 1;
}
#chi {
  display: inline;
  position: relative;
  top: -6px;
}
.top-alert {
  position: fixed;
  top: 70px;
  left: 0;
  width: 100%;
  z-index: 999;
}
/* ------ Bootstrap redefinition --- */
.btn-primary {
  color: var(--btn-primary-color);
  background-color: var(--btn-primary-bg-color);
  border-color: var(--btn-primary-border-color);
}
.btn-primary:hover,
.btn-primary:focus {
  color: var(--btn-primary-color-hover) !important;
  background-color: var(--btn-primary-bg-color-hover) !important;
  border-color: var(--btn-primary-border-color-hover) !important;
}
.nav-pills .nav-link {
  color: var(--navlink-color);
}
.nav-pills .nav-link:hover {
  color: var(--navlink-color-hover);
  background-color: var(--navlink-bg-hover);
}
.nav-pills .nav-link.active {
  background-color: var(--navlink-bg-color) !important;
  color: var(--navlink-color-active) !important;
}
/* ---------- Menu ---------- */
.menu-content {
  background-color: var(--menu_content_bg);
  padding: 0.5rem 1rem 2rem 1rem;
  border-radius: var(--border_curv);
  width: var(--menu_width);
}
.counter {
  color: #aaa;
}
.menu-title {
  font-size: 1.5rem;
  color: var(--menu_title_color);
  margin: 20px 0 5px 0;
}
.menu-item-bm a {
  font-size: 1.2rem;
  color: var(--bm-item-color);
  text-decoration: none;
}
.menu-item-bm a:hover {
  color: var(--bm-item-hover-color);
}
.menu-item label,
.menu-item a,
.menu-item input {
  cursor: pointer;
  text-decoration: none;
  color: var(--menu_item_color);
}
.menu-item label:hover,
.menu-item a:hover,
.menu-item input:hover {
  color: var(--menu_item_hover_color);
}
.paper {
  font-size: 1.1rem;
}
/* ---------- Main content block ---------- */
.paper-wrapper {
  border-radius: var(--border_curv);
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  font-size: 1.2rem;
  background-color: var(--wrap_bg_color);
  color: var(--wrap_color);
  overflow: hidden;
}
.footer {
  color: var(--menu_item_color);
  text-align: center;
  margin: 3rem 3rem 5rem 3rem;
}
.sub-alert {
  color: #f00;
}
.shade {
  opacity: 0.5;
}
.shift {
  padding: 0.25rem 0 2rem 2rem !important;
}
.non-standard-link {
  text-decoration: none;
  color: var(--wrap_color);
}
.non-standard-link:hover {
  text-decoration: none;
  color: var(--wrap_color);
}
.link-under:hover {
  text-decoration: underline;
}
a.disabled {
  /* And disable the pointer events */
  pointer-events: none;
}
.paper-day {
  padding: 0.5rem 1rem;
  border-color: var(--unseen-border-color);
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
}
.paper-day:hover {
  background-color: var(--seen-hover-bg);
  text-decoration: none;
}
.unseen {
  background-color: var(--unseen-paper-bg);
}
.paper-day.unseen:hover {
  background-color: var(--unseen-hover-bg) !important;
}
p > a {
  text-decoration: none;
}
p > a:hover {
  text-decoration: underline;
}
.close-btn {
  color: #f006;
  font-size: 1.6rem;
  cursor: pointer;
  display: inline;
  font-weight: bold;
  line-height: 1rem;
}
.close-btn:hover {
  color: #f00;
}
.modal-content {
  background-color: var(--wrap_bg_color);
  color: var(--wrap_color);
}
.form-block {
  padding-left: 3rem;
  padding-bottom: 2rem;
}
.cat-parent {
  cursor: move;
}
/* ----------tags------------- */
.tag-label {
  background-color: #aaa;
  color: #000;
  min-width: 110px;
  display: inline-block;
  margin: 2px 6px;
  padding: 5px;
  border: 4px solid transparent;
  border-radius: 20px;
  text-align: center;
  cursor: move;
}
#tag-list {
  margin: 2rem;
}
.rule-help {
  text-decoration: underline;
  cursor: pointer;
}
#tag-help {
  display: none;
  font-size: 1rem;
}
.add-set {
  background-color: #fff;
  border-style: dashed;
  border-width: 2px;
  border-color: #666;
  cursor: pointer;
}
#table-wrapper {
  display: none;
  padding: 5px 0 5px 0;
  font-size: 1rem;
}
#loading-tags {
  display: none;
  text-align: center;
  font-size: 1.4rem;
  color: #888;
}
.btn-edit {
  opacity: 20%;
  cursor: pointer;
}
.btn-edit:hover {
  opacity: 70%;
}
.success {
  color: var(--bs-success);
}
.problem {
  color: var(--bs-danger);
}
.btn-confirm {
  color: var(--bs-success);
  cursor: pointer;
}
#orcidWidget {
  color: #494a4c;
  font-family: Helvetica, Arial, sans-serif;
}
#orcidAuthButton {
  display: block;
  position: relative;
  width: auto;
  border: 1px solid #d3d3d3;
  border-radius: 5px;
  margin: 18px 0;
  text-align: center;
  padding: 0.6em;
  cursor: pointer;
  color: var(--wrap_color);
  text-decoration: none;
}
#orcidAuthButton:hover {
  background-color: var(--seen-hover-bg);
  border: solid 1px #d3d3d3;
}
`, "",{"version":3,"sources":["webpack://./less/settings.less","webpack://./less/layout.less"],"names":[],"mappings":"AAAA,kCAAkC;ACElC;EACE,qKAAA;EACA,6CAAA;ADAF;ACGA;EACE;IACE,yCAAA;EDDF;AACF;ACIA;EACE,yCAAA;ADFF;AACA,iCAAiC;ACKjC;EACE,kCAAA;ADHF;ACMA;EACE,oBAAA;EACA,qBAAA;ADJF;ACOA;EACE,WAAA;EACA,iBAAA;EACA,mEAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;ADLF;ACOE;EACE,WAAA;ADLJ;ACQE;EACE,WAAA;ADNJ;ACUA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;ADRF;ACWA;EACE,eAAA;EACA,kBAAA;EACA,SAAA;ADTF;ACYA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;ADVF;AACA,sCAAsC;ACatC;EACE,+BAAA;EACA,6CAAA;EACA,6CAAA;ADXF;ACaE;;EAEE,gDAAA;EACA,8DAAA;EACA,8DAAA;ADXJ;ACeA;EACE,2BAAA;ADbF;ACgBA;EACE,iCAAA;EACA,yCAAA;ADdF;ACiBA;EACE,oDAAA;EACA,6CAAA;ADfF;AACA,+BAA+B;ACmB/B;EACE,wCAAA;EACA,8BAAA;EACA,iCAAA;EACA,wBAAA;ADjBF;ACoBA;EACE,WAAA;ADlBF;ACqBA;EACE,iBAAA;EACA,8BAAA;EACA,oBAAA;ADnBF;ACsBA;EAEI,iBAAA;EACA,2BAAA;EACA,qBAAA;ADrBJ;ACuBI;EACE,iCAAA;ADrBN;AC0BA;;;EAII,eAAA;EACA,qBAAA;EACA,6BAAA;ADzBJ;AC2BI;;;EACE,mCAAA;ADvBN;AC4BA;EACE,iBAAA;AD1BF;AACA,6CAA6C;AC8B7C;EACE,iCAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,sCAAA;EACA,wBAAA;EACA,gBAAA;AD5BF;AC+BA;EACE,6BAAA;EACA,kBAAA;EACA,2BAAA;AD7BF;ACgCA;EACE,WAAA;AD9BF;ACiCA;EACE,YAAA;AD/BF;ACkCA;EACE,uCAAA;ADhCF;ACmCA;EACE,qBAAA;EACA,wBAAA;ADjCF;ACmCE;EACE,qBAAA;EACA,wBAAA;ADjCJ;ACsCE;EACE,0BAAA;ADpCJ;ACwCA;EDtCE,mCAAmC;ECwCnC,oBAAA;ADtCF;ACyCA;EACE,oBAAA;EACA,wCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;ADvCF;ACyCE;EACE,sCAAA;EACA,qBAAA;ADvCJ;AC2CA;EACE,wCAAA;ADzCF;AC4CA;EACE,mDAAA;AD1CF;AC6CA;EACE,qBAAA;AD3CF;AC6CE;EACE,0BAAA;AD3CJ;AA/KA;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AAiLF;AA/KE;EACE,WAAA;AAiLJ;AA7KA;EACE,sCAAA;EACA,wBAAA;AA+KF;AA5KA;EACE,kBAAA;EACA,oBAAA;AA8KF;AA3KA;EACE,YAAA;AA6KF;AACA,gCAAgC;AA1KhC;EACE,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AA4KF;AAzKA;EACE,YAAA;AA2KF;AAxKA;EACE,0BAAA;EACA,eAAA;AA0KF;AAvKA;EACE,aAAA;EACA,eAAA;AAyKF;AAtKA;EACE,sBAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAwKF;AArKA;EACE,aAAA;EACA,oBAAA;EACA,eAAA;AAuKF;AApKA;EACE,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AAsKF;AAnKA;EACE,YAAA;EACA,eAAA;AAqKF;AAnKE;EACE,YAAA;AAqKJ;AAjKA;EACE,wBAAA;AAmKF;AAhKA;EACE,uBAAA;AAkKF;AA/JA;EACE,wBAAA;EACA,eAAA;AAiKF;AA9JA;EACE,cAAA;EACA,yCAAA;AAgKF;AA7JA;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,wBAAA;EACA,qBAAA;AA+JF;AA5JA;EACE,sCAAA;EACA,yBAAA;AA8JF","sourcesContent":["@import \"layout.less\";\n\n.close-btn {\n  color: #f006;\n  font-size: 1.6rem;\n  cursor: pointer;\n  display: inline;\n  font-weight: bold;\n  line-height: 1rem;\n\n  &:hover {\n    color: #f00;\n  }\n}\n\n.modal-content {\n  background-color: var(--wrap_bg_color);\n  color: var(--wrap_color);\n}\n\n.form-block {\n  padding-left: 3rem;\n  padding-bottom: 2rem;\n}\n\n.cat-parent {\n  cursor: move;\n}\n\n/* ----------tags------------- */\n.tag-label {\n  background-color: #aaa;\n  color: #000;\n  min-width: 110px;\n  display: inline-block;\n  margin: 2px 6px;\n  padding: 5px;\n  border: 4px solid transparent;\n  border-radius: 20px;\n  text-align: center;\n  cursor: move;\n}\n\n#tag-list {\n  margin: 2rem;\n}\n\n.rule-help {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n#tag-help {\n  display: none;\n  font-size: 1rem;\n}\n\n.add-set {\n  background-color: #fff;\n  border-style: dashed;\n  border-width: 2px;\n  border-color: #666;\n  cursor: pointer;\n}\n\n#table-wrapper {\n  display: none;\n  padding: 5px 0 5px 0;\n  font-size: 1rem;\n}\n\n#loading-tags {\n  display: none;\n  text-align: center;\n  font-size: 1.4rem;\n  color: #888;\n}\n\n.btn-edit {\n  opacity: 20%;\n  cursor: pointer;\n\n  &:hover {\n    opacity: 70%;\n  }\n}\n\n.success {\n  color: var(--bs-success);\n}\n\n.problem {\n  color: var(--bs-danger);\n}\n\n.btn-confirm {\n  color: var(--bs-success);\n  cursor: pointer;\n}\n\n#orcidWidget {\n  color: #494a4c;\n  font-family: Helvetica, Arial, sans-serif;\n}\n\n#orcidAuthButton {\n  display: block;\n  position: relative;\n  width: auto;\n  border: 1px solid #d3d3d3;\n  border-radius: 5px;\n  margin: 18px 0;\n  text-align: center;\n  padding: 0.6em;\n  cursor: pointer;\n  color: var(--wrap_color);\n  text-decoration: none;\n}\n\n#orcidAuthButton:hover {\n  background-color: var(--seen-hover-bg);\n  border: solid 1px #d3d3d3;\n}\n","/* ---------- General ---------- */\n\nbody {\n  font-family: BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;\n  background-color: var(--background_color_mob);\n}\n\n@media (min-width: 768px) {\n  body {\n    background-color: var(--background_color);\n  }\n}\n\n.main-row {\n  background-color: var(--background_color);\n}\n\n/* ---------- Navbar ---------- */\n.navbar {\n  background-color: var(--title_red);\n}\n\n.nav-link {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n\n.page-title {\n  color: #fff;\n  font-size: 1.6rem;\n  font-family: 'Lucida Grande', helvetica, arial, verdana, sans-serif;\n  font-weight: bold;\n  text-decoration: none;\n  vertical-align: middle;\n\n  & a {\n    color: #fff;\n  }\n\n  &:hover {\n    color: #fff;\n  }\n}\n\n.login-block {\n  position: absolute;\n  right: 50px;\n  top: 10px;\n  z-index: 1;\n}\n\n#chi {\n  display: inline;\n  position: relative;\n  top: -6px;\n}\n\n.top-alert {\n  position: fixed;\n  top: 70px;\n  left: 0;\n  width: 100%;\n  z-index: 999;\n}\n\n/* ------ Bootstrap redefinition --- */\n.btn-primary {\n  color: var(--btn-primary-color);\n  background-color: var(--btn-primary-bg-color);\n  border-color: var(--btn-primary-border-color);\n\n  &:hover,\n  &:focus {\n    color: var(--btn-primary-color-hover) !important;\n    background-color: var(--btn-primary-bg-color-hover) !important;\n    border-color: var(--btn-primary-border-color-hover) !important;\n  }\n}\n\n.nav-pills .nav-link {\n  color: var(--navlink-color);\n}\n\n.nav-pills .nav-link:hover {\n  color: var(--navlink-color-hover);\n  background-color: var(--navlink-bg-hover);\n}\n\n.nav-pills .nav-link.active {\n  background-color: var(--navlink-bg-color) !important;\n  color: var(--navlink-color-active) !important;\n}\n\n/* ---------- Menu ---------- */\n\n.menu-content {\n  background-color: var(--menu_content_bg);\n  padding: 0.5rem 1rem 2rem 1rem;\n  border-radius: var(--border_curv);\n  width: var(--menu_width);\n}\n\n.counter {\n  color: #aaa;\n}\n\n.menu-title {\n  font-size: 1.5rem;\n  color: var(--menu_title_color);\n  margin: 20px 0 5px 0;\n}\n\n.menu-item-bm {\n  a {\n    font-size: 1.2rem;\n    color: var(--bm-item-color);\n    text-decoration: none;\n\n    &:hover {\n      color: var(--bm-item-hover-color);\n    }\n  }\n}\n\n.menu-item {\n  label,\n  a,\n  input {\n    cursor: pointer;\n    text-decoration: none;\n    color: var(--menu_item_color);\n\n    &:hover {\n      color: var(--menu_item_hover_color);\n    }\n  }\n}\n\n.paper {\n  font-size: 1.1rem;\n}\n\n/* ---------- Main content block ---------- */\n\n.paper-wrapper {\n  border-radius: var(--border_curv);\n  margin-bottom: 2rem;\n  padding-bottom: 2rem;\n  font-size: 1.2rem;\n  background-color: var(--wrap_bg_color);\n  color: var(--wrap_color);\n  overflow: hidden;\n}\n\n.footer {\n  color: var(--menu_item_color);\n  text-align: center;\n  margin: 3rem 3rem 5rem 3rem;\n}\n\n.sub-alert {\n  color: #f00;\n}\n\n.shade {\n  opacity: 0.5;\n}\n\n.shift {\n  padding: 0.25rem 0 2rem 2rem !important;\n}\n\n.non-standard-link {\n  text-decoration: none;\n  color: var(--wrap_color);\n\n  &:hover {\n    text-decoration: none;\n    color: var(--wrap_color);\n  }\n}\n\n.link-under {\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\na.disabled {\n  /* And disable the pointer events */\n  pointer-events: none;\n}\n\n.paper-day {\n  padding: 0.5rem 1rem;\n  border-color: var(--unseen-border-color);\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 1rem;\n\n  &:hover {\n    background-color: var(--seen-hover-bg);\n    text-decoration: none;\n  }\n}\n\n.unseen {\n  background-color: var(--unseen-paper-bg);\n}\n\n.paper-day.unseen:hover {\n  background-color: var(--unseen-hover-bg) !important;\n}\n\np > a {\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
